export const StoreCollectionsContext = 'store-collections'
